"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var stateMapper = require("./webmaf-player-state-mapper");
var webmaf_player_metadata_handler_1 = require("./webmaf-player-metadata-handler");
var END_OF_ASSET_THRESHOLD = 2;
var isAtEndOfAsset = function (duration, position) {
    return duration - position <= END_OF_ASSET_THRESHOLD;
};
var normalizeScreenDimension = function (value, maxValue) {
    var proportionalValue = -1 + (value / maxValue) * 2;
    return Math.max(-1, Math.min(1, proportionalValue));
};
var WebmafState = (function () {
    function WebmafState() {
    }
    WebmafState.buffering = 'buffering';
    WebmafState.endOfStream = 'endOfStream';
    WebmafState.notReady = 'notReady';
    WebmafState.opening = 'opening';
    WebmafState.paused = 'paused';
    WebmafState.playing = 'playing';
    WebmafState.DisplayingVideo = 'DisplayingVideo';
    WebmafState.stopped = 'stopped';
    WebmafState.unknown = 'unknown';
    return WebmafState;
}());
exports.WebmafState = WebmafState;
var WebMafPlayer = (function (_super) {
    __extends(WebMafPlayer, _super);
    function WebMafPlayer(window, webMafBridge) {
        var _this = _super.call(this) || this;
        _this.window = window;
        _this.webMafBridge = webMafBridge;
        _this.hasPlayerBeenStopped = false;
        _this.hasActionedDefaultAudioTrack = false;
        _this.sendSetVolumeCommand = function (volume) {
            _this.webMafBridge.sendCommand('setVolume', { volume: volume });
        };
        _this.sendPlayCommand = function () {
            _this.webMafBridge.sendCommand('play');
        };
        _this.sendPauseCommand = function () {
            _this.webMafBridge.sendCommand('pause');
        };
        return _this;
    }
    WebMafPlayer.prototype.initialise = function () {
        var _this = this;
        this.queue = [];
        this.readyToSeek = false;
        this.webMafBridge.listenToEvent('playerStatusChange', function (data) {
            var playerState = stateMapper.getPlayerState(data.playerState);
            var isNewStateValid = playerState !== null && playerState !== undefined;
            var isCurrentlyLoading = !_this.isContentAvailable && playerState !== client_lib_js_player_addons_common_player_1.PlayerState.Stopped;
            if (!_this.readyToSeek) {
                _this.readyToSeek = data.playerState === WebmafState.DisplayingVideo;
            }
            if (isNewStateValid && !isCurrentlyLoading) {
                _this.notifyStateChange(playerState);
                _this.runNextTaskFromQueue(playerState);
            }
        });
        this.webMafBridge.listenToEvent('getPlaybackTime', function (data) {
            _this.handlePlaybackTimeEvent(data);
        });
        this.webMafBridge.listenToEvent('playerError', function (data) {
            if (!_this.hasPlayerBeenStopped) {
                _this.queue = [];
                _this.notifyError({
                    code: data.error_code,
                    message: data.error_code_hexa,
                    isFatal: true,
                });
            }
        });
        this.webMafBridge.listenToEvent('getBitrate', function (data) {
            var bitrate = data.bitrate / 1000;
            _this.notifyBitrateChanged({ bitrateKbps: bitrate });
        });
        this.webMafBridge.listenToEvent('contentAvailable', function (data) {
            if (_this.onContentAvailableHandler) {
                _this.onContentAvailableHandler(data);
                _this.onContentAvailableHandler = null;
            }
        });
        this.webMafBridge.listenToEvent('getAudioTracks', function (data) {
            if (_this.lastEmittedAudioTracks !== data.audioTracks) {
                if (data.currentAudioTrack !== '') {
                    var tracks = _this.normalizeAudioTracks(data.audioTracks);
                    _this.notifyAvailableAudioTracksChanged(tracks);
                    _this.lastEmittedAudioTracks = data.audioTracks;
                }
            }
            _this.notifyCurrentAudioTrackChanged(data.currentAudioTrack);
        });
        this.webMafBridge.listenToEvent('playerMessage', function (data) {
            if (data.msg_info === 'setPlayTimeSuccess' && data.status === 'ok') {
                _this.readyToSeek = true;
            }
        });
        this.metadataHandler = new webmaf_player_metadata_handler_1.MetadataHandler(this.stateObservable, this.webMafBridge.sendCommand.bind(this.webMafBridge));
        return Promise.resolve();
    };
    WebMafPlayer.prototype.nativeLoad = function (nativeLoadData) {
        var _this = this;
        this.hasPlayerBeenStopped = false;
        var loadCommand = {
            contentUri: nativeLoadData.cdn.url,
        };
        if (nativeLoadData.drmConfiguration) {
            loadCommand.licenseUri = nativeLoadData.drmConfiguration.licenceAcquisitionUrl;
            loadCommand.customData = nativeLoadData.drmConfiguration.customChallengeData;
        }
        this.webMafBridge.sendCommand('load', loadCommand);
        this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Loading);
        this.setPlayoutRect(nativeLoadData.custom && nativeLoadData.custom.playoutRect);
        this.isContentAvailable = false;
        this.lastEmittedAudioTracks = '';
        this.isPlayingLiveContent = nativeLoadData.type === client_lib_js_player_addons_common_player_1.PlaybackType.Live;
        this.onContentAvailableHandler = function (data) {
            if (data.status !== 'ok') {
                return;
            }
            _this.setDefaultAudioTrack(nativeLoadData.defaultAudioLanguage);
            _this.isContentAvailable = true;
            if (nativeLoadData.position && nativeLoadData.position > 0) {
                var position = nativeLoadData.position;
                if (!isAtEndOfAsset(data.totalLength, position)) {
                    _this.webMafBridge.sendCommand('setPlayTime', { playTime: position });
                }
            }
        };
        this.metadataHandler.startRequestingMetadata();
    };
    WebMafPlayer.prototype.sendQueuedCommand = function (task) {
        if (this.isQueueEmpty()) {
            this.runTask(task);
        }
        this.addToQueue(task);
    };
    WebMafPlayer.prototype.nativePlay = function () {
        this.sendQueuedCommand(client_lib_js_player_addons_common_player_1.PlayerState.Playing);
    };
    WebMafPlayer.prototype.nativePause = function () {
        this.sendQueuedCommand(client_lib_js_player_addons_common_player_1.PlayerState.Paused);
    };
    WebMafPlayer.prototype.nativeStop = function () {
        this.queue = [];
        this.webMafBridge.sendCommand('stop');
        this.hasPlayerBeenStopped = true;
        this.metadataHandler.stopRequestingMetadata();
        this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Stopped);
        this.isContentAvailable = false;
        this.lastEmittedAudioTracks = '';
        this.isPlayingLiveContent = false;
        this.hasActionedDefaultAudioTrack = false;
    };
    WebMafPlayer.prototype.initiateSeek = function (timeSeconds) {
        if (this.readyToSeek) {
            this.readyToSeek = false;
            this.webMafBridge.sendCommand('setPlayTime', { playTime: timeSeconds });
        }
    };
    WebMafPlayer.prototype.dispose = function () {
        return Promise.resolve();
    };
    WebMafPlayer.prototype.setPlayoutRect = function (playoutRect) {
        var fullScreenRect = this.getFullScreenPlayoutRect();
        var rect = playoutRect || fullScreenRect;
        var webMafPlayoutRect = {
            ltx: normalizeScreenDimension(rect.x, fullScreenRect.width),
            lty: normalizeScreenDimension(fullScreenRect.height - rect.y, fullScreenRect.height),
            rbx: normalizeScreenDimension(rect.x + rect.width, fullScreenRect.width),
            rby: normalizeScreenDimension(fullScreenRect.height - rect.y - rect.height, fullScreenRect.height),
        };
        this.webMafBridge.sendCommand('setVideoPortalSize', webMafPlayoutRect);
    };
    WebMafPlayer.prototype.getFullScreenPlayoutRect = function () {
        return {
            x: 0,
            y: 0,
            width: this.window.innerWidth,
            height: this.window.innerHeight,
        };
    };
    WebMafPlayer.prototype.nativeSetAbrConfig = function (config) {
        this.webMafBridge.sendCommand('setFixVideoRepresentations', {
            minBitrate: config.minBitRate,
            maxBitrate: config.maxBitRate,
        });
    };
    WebMafPlayer.prototype.nativeSetAudioTrack = function (audioTrack) {
        this.webMafBridge.sendCommand('setAudioTrack', {
            audioTrack: audioTrack,
            restart: this.isPlayingLiveContent,
        });
    };
    WebMafPlayer.prototype.nativeSetVolume = function (volume) {
        this.sendSetVolumeCommand(volume);
    };
    WebMafPlayer.prototype.setDefaultAudioTrack = function (defaultAudioLanguage) {
        var _this = this;
        if (this.hasActionedDefaultAudioTrack) {
            return;
        }
        if (this.lastEmittedAudioTracks) {
            var availableAudioTracks = this.normalizeAudioTracks(this.lastEmittedAudioTracks);
            var firstAvailableAudioTrack = this.chooseFirstAvailableAudioTrack(defaultAudioLanguage, availableAudioTracks);
            this.nativeSetAudioTrack(firstAvailableAudioTrack);
        }
        else {
            var defaultAudioTrackListenerContext_1 = {};
            this.onAvailableAudioTracksChanged(function (availableAudioTracks) {
                var firstAvailableAudioTrack = _this.chooseFirstAvailableAudioTrack(defaultAudioLanguage, availableAudioTracks);
                _this.nativeSetAudioTrack(firstAvailableAudioTrack);
                _this.removeEventListeners(defaultAudioTrackListenerContext_1);
            }, defaultAudioTrackListenerContext_1);
        }
    };
    WebMafPlayer.prototype.normalizeAudioTracks = function (audioTracks) {
        return audioTracks
            .replace(' ', '')
            .split(',')
            .reduce(function (acc, track) {
            return acc.concat([{ language: track, trackId: track }]);
        }, []);
    };
    WebMafPlayer.prototype.chooseFirstAvailableAudioTrack = function (defaultAudioLanguage, availableAudioTracks) {
        if (Array.isArray(defaultAudioLanguage)) {
            return this.getFirstAvailableLanguage(defaultAudioLanguage, availableAudioTracks);
        }
        else if (defaultAudioLanguage) {
            return defaultAudioLanguage;
        }
        return availableAudioTracks[0].trackId;
    };
    WebMafPlayer.prototype.getFirstAvailableLanguage = function (defaultAudioLanguages, audioTracks) {
        return defaultAudioLanguages.find(function (language) { return audioTracks.find(function (track) { return track.trackId === language; }) !== undefined; });
    };
    WebMafPlayer.prototype.addToQueue = function (playerState) {
        this.queue.push(playerState);
    };
    WebMafPlayer.prototype.runNextTaskFromQueue = function (currentPlayerState) {
        var task = this.queue.shift();
        if (currentPlayerState === task) {
            return this.runNextTaskFromQueue(currentPlayerState);
        }
        this.runTask(task);
    };
    WebMafPlayer.prototype.runTask = function (task) {
        switch (task) {
            case client_lib_js_player_addons_common_player_1.PlayerState.Playing:
                this.sendPlayCommand();
                break;
            case client_lib_js_player_addons_common_player_1.PlayerState.Paused:
                this.sendPauseCommand();
                break;
            default:
        }
    };
    WebMafPlayer.prototype.isQueueEmpty = function () {
        return !Boolean(this.queue.length);
    };
    WebMafPlayer.prototype.handlePlaybackTimeEvent = function (data) {
        if (!this.isContentAvailable) {
            return;
        }
        var elapsedTime;
        if (this.isPlayingLiveContent && data.absoluteTime) {
            elapsedTime = parseInt(data.absoluteTime, 10);
            if (data.timeScale) {
                elapsedTime /= parseInt(data.timeScale, 10);
            }
        }
        else {
            elapsedTime = data.elapsedTime;
        }
        this.notifyCurrentPositionChanged(elapsedTime);
        this.notifyDurationChanged(data.totalTime);
    };
    return WebMafPlayer;
}(client_lib_js_player_addons_common_player_1.Player));
exports.WebMafPlayer = WebMafPlayer;
